import config from '@/config';
import createApiClient from '@/services/api/api-client';

// Create a pristine instance to avoid core API interceptors
export default createApiClient(config.VUE_APP_REST_API_URL);
